export default "__VITE_ASSET__CxF_Jj6O__"